/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Economics_Management30Inputs */

const en__field_enum_csjensblank_economics_management30 = /** @type {(inputs: _Field_Enum_Csjensblank_Economics_Management30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics & Management`)
};

const de__field_enum_csjensblank_economics_management30 = /** @type {(inputs: _Field_Enum_Csjensblank_Economics_Management30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaft & Management`)
};

/**
* | output |
* | --- |
* | "Economics & Management" |
*
* @param {_Field_Enum_Csjensblank_Economics_Management30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_economics_management30 = /** @type {((inputs?: _Field_Enum_Csjensblank_Economics_Management30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Economics_Management30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_economics_management30(inputs)
	return de__field_enum_csjensblank_economics_management30(inputs)
});
export { _field_enum_csjensblank_economics_management30 as "_field_enum_CSJENSBLANK_ECONOMICS_MANAGEMENT" }